import { NotificationsActiveOutlined } from "@mui/icons-material";
import { Badge, Menu } from "@mui/material";
import { useAppContext } from "Context/AppContext";
import { getRequest } from "api";
import { useEffect, useState } from "react";
import { NotiItem } from "./NotiItem";
import { NotificationInfo } from "../type";

interface NotificationDropdownPropType {
  numberOfNotiNotSeen: number;
  setNumberNotiOfNotSeen: React.Dispatch<React.SetStateAction<number>>;
  notiList: NotificationInfo[];
  setNotiList: React.Dispatch<React.SetStateAction<NotificationInfo[]>>;
}

export const NotificationDropdown = (props: NotificationDropdownPropType) => {
  const { notiList, numberOfNotiNotSeen, setNotiList, setNumberNotiOfNotSeen } =
    props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { onEvent, showNoteApp } = useAppContext();

  const handleClick = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setNumberNotiOfNotSeen(
      notiList.reduce((value, cur) => (value += 1 - cur.status), 0)
    );
  }, [notiList, setNumberNotiOfNotSeen]);

  useEffect(() => {
    onEvent("new-notification", newNoti => {
      setNotiList(prev => [newNoti, ...prev]);
    });
  }, [onEvent, setNotiList]);

  const seeNotification = (index: number) => {
    if (notiList[index].status) return;

    getRequest(`/notification/see-notification/${notiList[index].id}`);
    setNotiList(prev => {
      prev[index].status = 1;
      return prev;
    });
    setNumberNotiOfNotSeen(prev => prev - 1);
  };

  return (
    <div>
      <Badge
        id="notificaiton-dropdown"
        badgeContent={numberOfNotiNotSeen}
        color="error"
        sx={{ margin: "3px 5px 0 15px", cursor: "pointer" }}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <NotificationsActiveOutlined />
      </Badge>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        autoFocus={false}
        MenuListProps={{
          "aria-labelledby": "notificaiton-dropdown",
        }}
        PaperProps={{
          sx: {
            width: 320,
            right: showNoteApp ? 220 : 10,
            left: "auto !important",
            borderRadius: "10px",
            padding: "5px",
            marginTop: "10px",
            boxShadow: "none",
            border: "solid 1px #cacaca",
            maxHeight: "400px",
          },
        }}
      >
        {notiList.map((noti, index) => (
          <NotiItem
            key={index}
            handleCloseMenu={handleCloseMenu}
            noti={noti}
            handleSeeNoti={() => seeNotification(index)}
          />
        ))}
        {!notiList.length && (
          <div style={{ fontSize: 18, fontWeight: 600, marginLeft: 10 }}>
            Bạn hiện chưa có thông báo nào
          </div>
        )}
      </Menu>
    </div>
  );
};
